import "./navbarbuilder.css"
import React from 'react'
import CustomTemplatesContext from '../../../contexts/CustomTemplatesContext'
import { CustomTemplateRow } from '../customtemplates/CustomTemplateRow'
import {Nav} from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { ArrowBack } from "@mui/icons-material"
import { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css'
import StatusContext from '../../../contexts/StatusContext'
import AuthContext from '../../../contexts/AuthContext'
import { SaveChat } from '../savechat/SaveChat'
import {PushButton} from '../pushbutton/PushButton'
import CircularProgress from '@mui/material/CircularProgress';
import {LoginDialog} from '../logindialog/LoginDialog'

export const NavBarBuilder = ({ title })=> {
  const [expanded, setExpanded] = useState(false);
 

  let {
    deleteTemplate,
    displayTemplate,
    templates,
    templateName,
    setTemplateName,
    prompts,
    onSave,
    getTemplates,
   
} = React.useContext(CustomTemplatesContext);

let {
  isLoading,
  statusNavbar,
  setStatusNavbar,
  changeLanguage,
  setShowLoginDialog,
} = React.useContext(StatusContext);

const {
  checkCurrentUser,
} = React.useContext(AuthContext);

  
const handleonArrowClick = () => {
  console.log("HandleOnArrowClick")
  setExpanded(!expanded)
 
}
const handleonClickNavBar = async () => {

  setStatusNavbar("");
  if (checkCurrentUser() === false)
    {
        setShowLoginDialog(true)
        return;
    }
  getTemplates()
  setExpanded(!expanded)
 
}

const handleSelect = () => {
  setExpanded(!expanded)
}

const onTemplateNameChange = (e) => {

  setTemplateName(e.target.value)
  if (e.target.value.length)
    setStatusNavbar("");
}

  return (
    <Navbar expanded={expanded} key={false} bg="" expand={false} className="mb-2 py-0" sticky=''>
    
      {
          isLoading &&
            <div className='wait-icon'>
                <CircularProgress style={{ color: 'white' }}/>
            </div>
        }

      <div>
       <label className="navbarTitle"> {title}</label>
       <label className="navbarTemplateName"> {templateName} </label>
      </div>
      <div style = {{marginRight: '10px'}}>
        <PushButton onClick={handleonClickNavBar} label =  {changeLanguage('common','navbartopic')}/>
      </div>
   
    
        
        <Navbar.Offcanvas
          id={`offcanvasNavbar-expand-false`}
          aria-labelledby={`offcanvasNavbarLabel-expand-false`}
          placement="end"
          
        >
          <Offcanvas.Header onClick={handleSelect}>
            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-false`}>
            <ArrowBack className="styleIconWithBackground" onClick = {handleonArrowClick} />
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="justify-content-end flex-grow-1 pe-3">
              
            <label className="navbarTemplatesTitle">{changeLanguage('assistant', 'navbarsavedtitles')}</label>

            <div className="navbarContainer" >
           
              <ul className="navbarNames">
                  {
                      Array.isArray(templates) &&
                          templates.map((chat) => (
                              <CustomTemplateRow key = {chat.id} chat={chat} deleteHandler={deleteTemplate} clickHandler={displayTemplate} setExpand = {handleSelect} setTemplateName = {setTemplateName} />
                          ))
                  }
              </ul>
            </div>

            <br></br>
              <SaveChat label="Topic name" text={templateName} disabled={prompts===null || prompts.length === 0} onChange={onTemplateNameChange} onSave={onSave}/>
           

            {
              (statusNavbar) &&
                      <div style={{ color: "red" }}><label>{statusNavbar}</label></div> 
            } 
            <br></br>

            <div className='navbarFonts'>
                
              {changeLanguage('templates', 'navbartext1')}
              <br></br>
              <br></br>
      
              {changeLanguage('templates', 'navbartext2')}    
              <br></br>
              <br></br>
                
              {changeLanguage('templates', 'navbartext3')}    
              <br></br>
              <br></br>

              {changeLanguage('templates', 'navbartext4')}    
              <br></br>
              <br></br>

             
              {changeLanguage('templates', 'navbartext5')}    
              <br></br>
              <br></br>

              
            </div>

            </Nav>
           
             <LoginDialog />
          </Offcanvas.Body>
        </Navbar.Offcanvas>
    
    </Navbar>
  );
}

export default NavBarBuilder;